import React, { useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import CustomButton from 'components/CustomInput/Button';
import styled from 'styled-components';
import { setGlobal } from 'store/global/reducer';
import parse from 'html-react-parser/dist/html-react-parser';

const SContent = styled.div`
    min-width: 400px;
    font-weight: 500;
`;

const ErrorModal = () => {
    const isShow = useSelector((state) => state.global.isErrorShow);
    const errorMessage = useSelector((state) => state.global.errorMessage);
    const errorTitle = useSelector((state) => state.global.errorTitle);
    const errorButton = useSelector((state) => state.global.errorButton);

    const dispatch = useDispatch();

    const handleOk = () => {
        dispatch(
            setGlobal({
                isErrorShow: false,
            }),
        );
    };

    useEffect(() => {
        if (!isShow) {
            setGlobal({
                errorTitle: undefined,
                errorMessage: undefined,
                errorButton: 'Confirm',
            });
        }
    }, [isShow]);

    return (
        <Dialog open={isShow ?? false} style={{ margin: 'auto' }}>
            <DialogTitle style={{ fontWeight: 'bold', width: 400 }}>
                <div style={{ fontSize: 16 }}>{errorTitle ?? 'Error'}</div>
            </DialogTitle>
            <DialogContent>
                {errorMessage && (
                    <SContent>
                        <DialogContentText>
                            <div style={{ whiteSpace: 'pre-line' }}>{parse(errorMessage)}</div>
                        </DialogContentText>
                    </SContent>
                )}
            </DialogContent>
            <DialogActions style={{ padding: 15 }}>
                <CustomButton onClick={handleOk} autoFocus>
                    {errorButton ?? 'Confirm'}
                </CustomButton>
            </DialogActions>
        </Dialog>
    );
};

export default ErrorModal;
